var DirectorySearchHomepage = {

    keywordField: null,
    jurisdictionField: null,
    alljurisdictionOptions: null,
    practiceAreaField: null,
    formFilterHolder: null,

    applyButton: null,

    directoryUrl: '',

    me: this,

    InitDirectorySearch: function (_directoryPage) {
        this.directoryUrl = _directoryPage;

        this.keywordField = document.querySelector('#keywords');
        this.jurisdictionField = document.querySelector('#jurisdictions');
        this.practiceAreaField = document.querySelector('#PracticeArea');
        this.memberFirmField = document.querySelector('#memberFirms');
        this.formFilterHolder = document.querySelector('#directoryFilters');

        this.applyButton = document.querySelector('#applyButtonHome');

        this.SetupEvents();
    },

    BuildParameterList: function () {
        //var filters = this.filtersCurrentState;

        this.selectedKeywords = this.keywordField.value;
        this.selectedJurisdiction = this.jurisdictionField.value;
        this.selectedPracticeAreas = this.practiceAreaField.value;
        this.selectedMemberFirm = this.memberFirmField.value;


        // Add these to the hash
        var tempHash = '';
        if (notNullUndefinedOrEmpty(this.selectedKeywords)) {
            tempHash += '&keyword=' + this.selectedKeywords;
        }
        if (notNullUndefinedOrEmpty(this.selectedJurisdiction)) {
            tempHash += '&jurisdictions=' + this.selectedJurisdiction;
        }
        if (notNullUndefinedOrEmpty(this.selectedPracticeAreas)) {
            tempHash += '&practiceAreas=' + this.selectedPracticeAreas;
        }
        if (notNullUndefinedOrEmpty(this.selectedMemberFirm)) {
            tempHash += '&memberFirm=' + this.selectedMemberFirm;
        }

        if (notNullUndefinedOrEmpty(tempHash)) {
            tempHash = tempHash.replace(tempHash.charAt(0), "#");
        }

        // Also cookie the hash for the back button?
        Cookies.set('DirSettings', tempHash.replace('#', ''));

        return tempHash;
    },

    HashToArray: function (hash) {
        if (notNullUndefinedOrEmpty(hash)) {
            var result = hash.split('&').reduce(function (res, item) {
                var parts = item.split('=');
                res[parts[0]] = parts[1];
                return res;
            }, {});
            return result;
        } else {
            return [];
        }
    },

    SetupEvents: function () {

        // Apply button
        this.applyButton.addEventListener('click', function (e) {
            this.DoDirectorySearch();
        }.bind(this));

        // Dropdowns
        this.formFilterHolder.querySelectorAll('select').forEach((selectGroup) => {
            selectGroup.addEventListener('change', function (e) {

                if (e.target.value != ''|| e.target.options[e.target.selectedIndex].classList.contains('region')) {
                    e.target.classList.add('active');
                } else {
                    e.target.classList.remove('active');
                }
            }.bind(this));
        });

    },

    DoDirectorySearch: function (_pageNo) {
        var hash = this.BuildParameterList();
        console.log(hash);

        if (notNullUndefinedOrEmpty(hash)) {
            document.location.href = this.directoryUrl + hash;
        //} else {
            //alert("Please select an option");
        }


    }

}